module.exports = __webpack_public_path__ + "static/icons/icon-point-3ccc216ec5f83cb47d81cda02a9e311a.svg";